import {
  Box,
  Button,
  CardActionArea,
  IconButton,
  Menu,
  MenuItem,
} from "@material-ui/core";
import { TextField } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import AppBar from "@material-ui/core/AppBar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import LocalPharmacyIcon from "@material-ui/icons/LocalPharmacy";
import AppsIcon from "@material-ui/icons/Apps";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  deleteStoreAction,
  editStoreAction,
  getStoresAction,
} from "../../../../store/store/actions";
import {
  addSessionData,
  getSessionData,
  getUserModules,
  removeSessionData,
} from "../../base/helper/baseHelper";
import { info } from "../../../../store/notification/actions";
import ConfirmationDialog from "../../base/views/ConfirmationDialog";
import UserProfile from "../../base/views/UserProfile";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";
import TimelineIcon from "@material-ui/icons/Timeline";
import Popup from "../../base/views/Popup";
import EditPharmacy from "./EditPharmacy";
import { Group } from "@material-ui/icons";

const Dashboard = (props) => {
  const useStyles = makeStyles((theme) => ({
    heroContent: {
      padding: theme.spacing(8, 0, 6),
    },
    cardGrid: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(8),
    },
    card: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderBottomRightRadius: "1rem",
      borderBottomLeftRadius: "1rem",
    },
    cardContent: {
      flexGrow: 1,
    },
    appBar: {
      // backgroundColor: "cornflowerblue",
      backgroundColor: "white",
      backdropFilter: "blur(6px)",
    },
    title: {
      flexGrow: 1,
      color: "rgba(0, 0, 0, 0.7);",
    },
    horizontalList: {
      marginTop: "30px",
      display: "flex",
      flexDirection: "reverse",
    },
    dot: {
      height: "10px",
      width: "20px",
      borderRadius: "30%",
      display: "inline-block",
    },
    margin: {
      margin: theme.spacing(1),
    },
  }));
  const history = useHistory();
  const { stores, getStores, deleteStore, editStore } = props;
  const [isglobal, setGlobal] = useState("0");
  const [userId, setUserId] = useState("");
  const [isAdmin, setAdmin] = useState("0");
  const [openDialog, setOpenDialog] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedStoreId, setSelectedStoreId] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [recordForEdit, setRecordForEdit] = useState(null);

  const addOrEdit = (resetForm) => {
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
  };

  useEffect(() => {
    removeSessionData({ key: "store" });
    removeSessionData({ key: "userModules" });
  });

  useEffect(() => {
    setUserId(getSessionData({ key: "userId" }));
    setGlobal(getSessionData({ key: "isglobalUser" }));
    setAdmin(getSessionData({ key: "isAdmin" }));
    if (isAdmin === "1") {
      history.push({ pathname: "/masterProducts" });
    } else if (userId) {
      info("Loading Pharmacy Dashboard...");
      getStores(userId);
    }
  }, [userId, getStores, isAdmin, history]);

  const handleClick = async (store) => {
    await getUserModules(userId, store.storeid).then((res) => {
      addSessionData({ key: "userModules", value: JSON.stringify(res.data) });
    });
    addSessionData({ key: "store", value: JSON.stringify(store) });
    history.push({ pathname: "/dashboard" });
  };

  const handleDelete = () => {
    deleteStore({ storeId: selectedStoreId, userId });
    setOpenDialog(false);
  };

  const handleMenuClick = (event, storeid) => {
    setAnchorEl(event.currentTarget);
    setSelectedStoreId(storeid);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = (e) => {
    handleClose();
    const store = stores.find((s) => s.storeid === selectedStoreId);
    setOpenPopup(true);
    setRecordForEdit({ ...store });
  };

  const getStoreBgColor = (planEndDate) => {
    let cardColor = {};
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const expirydate = new Date(
      parseInt(planEndDate.split("-")[0]),
      parseInt(planEndDate.split("-")[1]) - 1,
      parseInt(planEndDate.split("-")[2])
    );
    const currentDate = new Date();
    const diffDays = Math.round(Math.abs((expirydate - currentDate) / oneDay));

    if (diffDays > 30) {
      cardColor.backgroundColor = "rgba(76, 175, 80, 0.5)";
    } else if (diffDays <= 30) {
      cardColor.backgroundColor = "rgba(255, 152, 0, 0.5)";
    } else if (diffDays < 0) {
      cardColor.backgroundColor = "rgba(244, 67, 54, 0.5)";
    }
    return cardColor;
  };

  const classes = useStyles();
  return (
    <div>
      <AppBar position="fixed" className={classes.appBar} elevation={0}>
        <Toolbar>
          <Typography
            component="h1"
            variant="h5"
            noWrap
            className={classes.title}
          >
            <Button
              onClick={() => history.push("/home")}
              startIcon={<TimelineIcon />}
            >
              AIMS
            </Button>
          </Typography>
          <Tooltip title="Go to Apps">
            <IconButton onClick={() => history.push("/apps")}>
              <AppsIcon />
            </IconButton>
          </Tooltip>
          {isglobal === "1" && (
            <Tooltip title="Add Pharmacy">
              <IconButton
                size="medium"
                onClick={() => history.push("/purchaseSubscription")}
              >
                <LocalPharmacyIcon />
              </IconButton>
            </Tooltip>
            // <Button
            //   variant="outlined"
            //   size="medium"
            //   startIcon={<LocalPharmacyIcon />}
            //   onClick={()=>history.push("/purchaseSubscription")}
            // >
            // </Button>
          )}
          <Tooltip title="User Management">
            <IconButton onClick={() => history.push("/activeUsers")}>
              <Group />
            </IconButton>
          </Tooltip>
          <UserProfile />
        </Toolbar>
      </AppBar>
      <main>
        <CssBaseline />
        <div className={classes.heroContent}>
          <Typography
            component="h1"
            variant="h2"
            align="center"
            color="textPrimary"
            gutterBottom
          >
            {/* Pharmacy Dashboard */}
            My Pharmacies
          </Typography>
          <Container className={classes.cardGrid} maxWidth="lg">
            <Grid container spacing={4}>
              {stores.map((store, i) => {
                return (
                  <Grid item key={store.storeid} xs={12} sm={12} md={3}>
                    <Card className={classes.card}>
                      <CardHeader
                        style={getStoreBgColor(store.planenddate)}
                        avatar={
                          <LocalPharmacyIcon
                            className="text-center"
                            fontSize="large"
                          />
                        }
                        action={
                          store.adminflag === "1" && (
                            <IconButton
                              aria-label="settings"
                              onClick={(e) => handleMenuClick(e, store.storeid)}
                            >
                              <MoreVertIcon fontSize="small" />
                            </IconButton>
                          )
                        }
                        title={store.storename.toUpperCase()}
                      />

                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        id={i}
                      >
                        <MenuItem onClick={handleEdit}>
                          <EditIcon fontSize="small" /> Edit
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleClose();
                            setOpenDialog(true);
                          }}
                        >
                          <DeleteIcon fontSize="small" /> Delete
                        </MenuItem>
                      </Menu>

                      <CardActionArea>
                        <CardContent
                          onClick={() => {
                            handleClick(store);
                          }}
                          className={classes.cardContent}
                        >
                          <Typography>
                            <b>Address:</b>{" "}
                            {`${store.street1}, ${store.city}, ${store.state}, ${store.country}, ${store.zipcode}`}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>

            <Popup
              title="Edit Pharmacy"
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
            >
              <EditPharmacy
                recordForEdit={recordForEdit}
                addOrEdit={addOrEdit}
                editStore={editStore}
              />
            </Popup>
            <List className={classes.horizontalList}>
              <ListItem m={0} style={{ width: "25rem" }}>
                <Box
                  className={classes.dot}
                  m={1}
                  bgcolor="success.main"
                  p={1}
                ></Box>

                <ListItemText primary="Valid Subscription" />
              </ListItem>
              <ListItem p={0} m={0} style={{ width: "35rem" }}>
                <Box
                  className={classes.dot}
                  m={1}
                  bgcolor="warning.main"
                  p={1}
                ></Box>

                <ListItemText primary="Subscription expires in 30 days" />
              </ListItem>
              <ListItem m={0} p={0}>
                <Box
                  className={classes.dot}
                  m={1}
                  bgcolor="error.main"
                  p={1}
                ></Box>

                <ListItemText primary="Subscription Expired" />
              </ListItem>
            </List>
          </Container>
        </div>
      </main>
      <LandingPageFooter />
      <ConfirmationDialog
        title="Do you want to proceed?"
        openDialog={openDialog}
        closeDialog={setOpenDialog}
        popupTitle="Stores"
        onSubmit={handleDelete}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return { stores: state.store };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getStores: (userId) => dispatch(getStoresAction(userId)),
    editStore: (store) => dispatch(editStoreAction(store)),
    deleteStore: (store) => dispatch(deleteStoreAction(store)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
